import { render } from "./AIScoreResult.vue?vue&type=template&id=7ec342b2"
import script from "./AIScoreResult.vue?vue&type=script&lang=js"
export * from "./AIScoreResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__